export const METRICS_MAP = {
  views: {
    name: 'views' as const,
    label: 'Views',
    isDuration: false,
    tooltip: 'Total views of a post\nwithin Slab, emails,\nor integrations',
    color: '#ea3c84',
  },
  reads: {
    name: 'reads' as const,
    label: 'Read time',
    isDuration: true,
    tooltip: 'Total time users\nspent reading posts\nwithin Slab',
    color: '#207af1',
  },
};

const METRICS = [METRICS_MAP.views, METRICS_MAP.reads] as const;

export default METRICS;
